var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.556,
    height: 17.556,
    viewBox: "0 0 17.556 17.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pricing",
    transform: "translate(-120 -944.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_balance_FILL0_wght400_GRAD0_opsz48",
    d: "M6.9,16.873V9.433H8.214v7.44Zm5.311,0V9.433h1.317v7.44ZM4,19.506V18.19H21.556v1.317Zm13.343-2.633V9.433H18.66v7.44ZM4,8.117V6.954l8.778-5,8.778,5V8.117ZM6.941,6.8h0Zm0,0H18.616L12.778,3.464Z",
    transform: "translate(116 942.271)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.dc4d5ad10fecfd0027ba78239d6b5fab.svg";
export { ForwardRef as ReactComponent };